import { Box, Text, CircularProgress } from "@chakra-ui/react";
import { useSelector } from "react-redux";

export default function ProgressComponent() {
    const { statisticsData, isLoading } = useSelector(state => state.statisticsState)

    return (
        <Box
            w='100%'
            d='flex'
            flexDir='column'
        >
            <Text
                fontSize='15px'
                color='#222222'
                fontWeight='800'
                style={{ fontFamily: 'Mulish, sans-serif' }}
                mb='1rem'
            >
                PROGRESS
            </Text>

            <Box
                border='1px solid rgba(0, 0, 0, 0.1)'
                borderRadius='10px'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
                w='100%'
                bg='#ffffff'
                d='flex'
                flexDir='column'
                px='1.5rem'
                py='0.5rem'
            >
                <Box
                    w='100%'
                    d='flex'
                    alignItems='flex-start'
                    py='1rem'
                    flexDir='column'
                    borderBottom='1px solid rgba(0, 0, 0, 0.05)'
                >
                    <Text
                        fontSize='10px'
                        color='#798599'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        mb='1rem'
                        textTransform='uppercase'
                    >
                        Course Progress
                    </Text>

                    {
                        isLoading ? <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                            <CircularProgress isIndeterminate color='#3e59de' size='20px' />
                        </Box> :
                            <Box
                                w='100%'
                                height='18px'
                                bg='rgba(242, 92, 58, 0.2)'
                                boxShadow=' 0px 1px 3px rgba(0, 0, 0, 0.15)'
                                borderRadius='4px'
                            >

                                <Box height='100%'
                                    bgColor='#F25C3A'
                                    width={`${statisticsData?.course_progress}%`}
                                    d='flex'
                                    justifyContent='center'
                                    alignItems='center'
                                    borderRadius='4px'
                                    fontSize='10px'
                                    color='#ffffff'
                                    fontWeight='700'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                >
                                    <Text>
                                        {statisticsData?.course_progress}%
                                    </Text>
                                </Box>

                            </Box>
                    }
                </Box>

                <Box
                    w='100%'
                    d='flex'
                    alignItems='flex-start'
                    py='1rem'
                    flexDir='column'
                >
                    <Text
                        fontSize='10px'
                        color='#798599'
                        fontWeight='800'
                        style={{ fontFamily: 'Mulish, sans-serif' }}
                        mb='1rem'
                        textTransform='uppercase'
                    >
                        Today's Progress
                    </Text>
                    {
                        isLoading ? <Box width='100%' d='flex' justifyContent='center' alignItems='center'>
                            <CircularProgress isIndeterminate color='#3e59de' size='20px' />
                        </Box> :
                            <Box
                                w='100%'
                                height='18px'
                                bg='#00A9DE33'
                                boxShadow=' 0px 1px 3px rgba(0, 0, 0, 0.15)'
                                borderRadius='4px'
                            >

                                <Box height='100%'
                                    bgColor='#00A9DE'
                                    width={`${statisticsData?.todays_progress}%`}
                                    d='flex'
                                    justifyContent='center'
                                    alignItems='center'
                                    borderRadius='4px'
                                    fontSize='10px'
                                    color='#ffffff'
                                    fontWeight='700'
                                    style={{ fontFamily: 'Mulish, sans-serif' }}
                                >
                                    <Text>
                                        {statisticsData?.todays_progress}%
                                    </Text>
                                </Box>

                            </Box>
                    }
                </Box>

            </Box>
        </Box>
    )
}

